import { render } from "./ObjectValue.vue?vue&type=template&id=495de7e9"
import script from "./ObjectValue.vue?vue&type=script&lang=js"
export * from "./ObjectValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__